import { Link } from "react-router-dom";
import { company, services } from "@/data/company";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#0a0f1e]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-5">
            <img
              src="/logo-footer.png"
              alt={`${company.name} logo`}
              className="h-20 w-auto object-contain"
            />
          </div>
          <p className="text-slate-400 max-w-sm leading-relaxed text-sm">
            {company.tagline}. We forge the software and marketing engines that
            power modern businesses.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold mb-4">
            Services
          </h4>
          <ul className="space-y-2">
            {services.slice(0, 5).map((s) => (
              <li key={s.key}>
                <Link
                  to="/services"
                  className="text-sm text-slate-400 hover:text-[#22d3ee] transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold mb-4">
            Company
          </h4>
          <ul className="space-y-2">
            <li>
              <Link to="/about" className="text-sm text-slate-400 hover:text-[#22d3ee] transition-colors">
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-sm text-slate-400 hover:text-[#22d3ee] transition-colors">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/blog" className="text-sm text-slate-400 hover:text-[#22d3ee] transition-colors">
                Blog
              </Link>
            </li>
            <li>
              <Link
                to="/admin"
                data-testid="footer-admin-link"
                className="text-sm text-slate-400 hover:text-[#22d3ee] transition-colors"
              >
                Admin
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-slate-500">
            <a href="#" className="hover:text-[#22d3ee] transition-colors">Privacy</a>
            <a href="#" className="hover:text-[#22d3ee] transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
